// extracted by mini-css-extract-plugin
export default {"checkbox":"CircleCheckbox_checkbox__Fzzps","disabled":"CircleCheckbox_disabled__OXvYd"};